import React, { useContext } from "react";
import { ECLRichTextEditor } from "../../index";
import { ToastContext } from "../../../utilities/contexts";
import { sourceOneRestRequest } from "../../../utilities/requests";

export default function ECLSendMessage(props) {
   //PROPS
   //userId - string - who we're sending this message to
   const addToast = useContext(ToastContext);

   async function handleMessageSubmit(rawText) {
      // console.log(rawText)
      if (rawText !== "") {
         const params = {
            query_type: "send_message",
            assignee: props.userId,
            message: rawText,
         };
         sourceOneRestRequest(params)
            .then(() => {
               addToast("Message sent");
            })
            .catch((error) => {
               console.error(error);
               addToast("There was an error sending your message.", "error");
            });
      } else {
         addToast("You attempted to send an empty message.", "error");
      }
   }

   return (
      <div className="ecl-send-message">
         <ECLRichTextEditor
            submitButtonText="Send Message"
            onSubmit={handleMessageSubmit}
         />
      </div>
   );
}
